import {
  Alert01Icon,
  ArtificialIntelligence08Icon,
  InformationCircleIcon,
  ThumbsUpIcon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import DOMPurify from 'dompurify';

import { QuestionResponses } from './QuestionResponses/QuestionResponses';

export const FormResponses = ({ fields, aiSummary, noAiSummary = false }) => {
  return (
    <div className="bg-slate-50 flex flex-col gap-8 p-8">
      {!noAiSummary && (
        <div className="bg-neutral-1 rounded-3xl p-8 border border-neutral-4 shadow-sm">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <HugeiconsIcon
                icon={ArtificialIntelligence08Icon}
                size={20}
                className="text-primary-4"
                strokeWidth={2}
              />
              <span className="text-2xl font-medium text-neutral-7">AI Reference Summary</span>
            </div>
            <span
              className="text-xl text-neutral-6 font-regular"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(aiSummary?.overall_summary ?? ''),
              }}
            />
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              {aiSummary?.key_strengths.map((keyStrength, index) => (
                <div key={index} className="bg-neutral-2 rounded-2xl p-4 border border-neutral-4">
                  <div className="flex items-center gap-2">
                    <HugeiconsIcon
                      icon={ThumbsUpIcon}
                      size={24}
                      className="text-green-2 bg-green-1 rounded-xl p-2"
                    />
                    <span className="text-sm font-medium text-neutral-6 uppercase">
                      {keyStrength.title}
                    </span>
                  </div>
                  <div className="flex flex-col gap-2">
                    <span className="text-xl font-medium text-neutral-7">
                      {keyStrength.summary}.&nbsp;
                      <span className="text-xl font-light text-neutral-6">
                        {keyStrength.evidence}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
              {aiSummary?.areas_of_concern.map((concern, index) => (
                <div key={index} className="bg-neutral-2 rounded-2xl p-4 border border-neutral-4">
                  <div className="flex items-center gap-2">
                    <HugeiconsIcon
                      icon={Alert01Icon}
                      size={24}
                      className="text-red-2 bg-red-1 rounded-xl p-2"
                    />
                    <span className="text-sm font-medium text-neutral-6 uppercase">
                      {concern.title}
                    </span>
                  </div>
                  <div className="flex flex-col gap-2">
                    <span className="text-xl font-medium text-neutral-7">
                      {concern.summary}.&nbsp;
                      <span className="text-xl font-light text-neutral-6">{concern.evidence}</span>
                    </span>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex justify-between mt-4 pt-4 border-t border-neutral-4 border-dashed">
              <div className="flex items-center gap-2">
                <HugeiconsIcon
                  icon={InformationCircleIcon}
                  size={16}
                  className="text-text-tertiary"
                />
                <span className="text-lg font-regular text-text-tertiary">
                  Generated based on the referee's responses using AI
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-lg font-regular text-text-tertiary border-r border-neutral-4 pr-2">
                  Summary can be inaccurate
                </span>
                <a
                  href="mailto:support@checkmate.tech"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg font-medium text-primary-4">
                  Send feedback
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
      {fields.map((field, index) => (
        <QuestionResponses key={field.id} order={index + 1} field={field} params={{}} />
      ))}
    </div>
  );
};
